import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useAuth } from "../contexts/AuthContext";
import { useAppState } from "../contexts/WorkoutContext";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { LogIn } from "lucide-react";
import FeedTab from "../components/social/FeedTab";
import FriendsTab from "../components/social/FriendsTab";
import GroupsTab from "../components/social/GroupsTab";

const SocialView = () => {
  const { user } = useAuth();
  // Controlled, so a notification can open the tab its news belongs to
  // (like settingsSheet — see WorkoutContext).
  const { socialTab, setSocialTab } = useAppState();
  // Live was a tab of its own until #86; it now sits at the top of the feed.
  const tab = socialTab === "live" ? "feed" : socialTab;

  if (!user) {
    return (
      <div className="max-w-3xl mx-auto">
        <Card className="w-full max-w-2xl mx-auto">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
              <LogIn className="h-6 w-6 text-primary" />
            </div>
            <CardTitle>Sign in required</CardTitle>
            <CardDescription>Sign in to connect with mates, share workouts, and train together.</CardDescription>
          </CardHeader>
          <CardContent className="text-center text-muted-foreground">
            <p>Sign in with Google from the account menu.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <Tabs value={tab} onValueChange={setSocialTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="feed">Feed</TabsTrigger>
          <TabsTrigger value="mates">Mates</TabsTrigger>
          <TabsTrigger value="groups">Groups</TabsTrigger>
        </TabsList>
        <TabsContent value="feed">
          <FeedTab />
        </TabsContent>
        <TabsContent value="mates">
          <FriendsTab />
        </TabsContent>
        <TabsContent value="groups">
          <GroupsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SocialView;
